var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticStyle:{"width":"50px"},attrs:{"src":_vm.sistemurl + _vm.data.images,"alt":""},on:{"click":function($event){_vm.$router
        .push({
          name: 'ecommerce-item-detail-view',
          params: { item_id: _vm.data.maddeKodu },
        })
        .catch(function () {})}}})])}
var staticRenderFns = []

export { render, staticRenderFns }